// extracted by mini-css-extract-plugin
export var text = "_ah-0";